import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FormikProvider from '../../shared/forms/formikProvider.component';
import Modal from '../../shared/modals/modal.component';
import Form from '../../shared/forms/form.component';

import getSchema from './categoryForm.schema';

import { OptionsPropType } from '../../shared/propTypes/common';

import {
  hideCategoryModalForAddEdit,
  saveCategory,
} from './store/actions';

import {
  defaultTagSelector,
  catViewSelector,
  isSavingCategoriesInProgressSelector,
  categoriesOptionsSelector,
} from './store/selectors';

const ModalTitles = {
  ADD: 'Add Category',
  EDIT: 'Edit Category',
};

class AddCategoriesModal extends PureComponent {
  static propTypes = {
    period: PropTypes.shape({
      name: PropTypes.string,
    }).isRequired,

    openForEdit: PropTypes.bool,
    isSavingInProgress: PropTypes.bool.isRequired,

    hideModal: PropTypes.func.isRequired,
    saveEntity: PropTypes.func.isRequired,

    defaultTagOptions: OptionsPropType,
    catViewOptions: OptionsPropType,
    categoriesOptions: OptionsPropType,

    entityToEdit: PropTypes.shape({
      categoryName: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      catView: PropTypes.string.isRequired,
      defaultTag: PropTypes.string,
      subCategoryName: PropTypes.string,
    }),
    isVisible: PropTypes.bool,
  };

  state = {
    addAnother: false,
  };

  save = (categoryData, { setSubmitting, resetForm }) => {
    const { period, saveEntity, openForEdit } = this.props;
    const { addAnother } = this.state;

    this.setState({ addAnother: false }, () => {
      saveEntity({
        categoryData,
        periodName: period.name,
      }, openForEdit, { callback: resetForm, keepOpenAfterSaving: addAnother });
      setSubmitting(false);
    });
  };

  renderModal = ({ formik, schema }) => {
    const {
      openForEdit,
      hideModal,
      isVisible,
      isSavingInProgress,
      catViewOptions,
      defaultTagOptions,
      categoriesOptions,
    } = this.props;

    const submit = () => {
      this.setState({
        addAnother: false,
      }, () => formik.handleSubmit());
    };

    const submitAndAddAnotherAction = () => {
      this.setState({
        addAnother: true,
      }, () => formik.handleSubmit());
    };

    const reset = () => {
      hideModal();
      formik.resetForm();
    };

    return (
      <Modal
        className="add-category-modal"
        title={openForEdit ? ModalTitles.EDIT : ModalTitles.ADD}
        closeAction={reset} // eslint-disable-line react/jsx-no-bind
        dismissText="Cancel"
        dismissAction={reset} // eslint-disable-line react/jsx-no-bind
        submitText="Save"
        submitAction={submit} // eslint-disable-line react/jsx-no-bind
        isSubmitting={formik.isSubmitting || isSavingInProgress}
        submitAndAddAnotherAction={!openForEdit ? submitAndAddAnotherAction : null}
        submitAndAddAnotherText="Save and Add Another"
        isVisible={isVisible}
      >
        <Form
          formik={formik}
          schema={schema}
          openForEdit={openForEdit}
          formContext={{
            catViewOptions,
            defaultTagOptions: openForEdit ? defaultTagOptions : [],
            categoriesOptions,
          }}
        />
      </Modal>
    );
  };

  render() {
    const { entityToEdit, categoriesOptions } = this.props;

    return (
      <FormikProvider
        schema={getSchema(entityToEdit)}
        entityToEdit={entityToEdit}
        onSubmit={this.save}
        render={this.renderModal}
        validationContext={{ categoriesOptions }}
      />
    );
  }
}

const mapStateToProps = state => ({
  isSavingInProgress: isSavingCategoriesInProgressSelector(state),
  defaultTagOptions: defaultTagSelector(state),
  catViewOptions: catViewSelector(state),
  categoriesOptions: categoriesOptionsSelector(state),
});

export default connect(
  mapStateToProps,
  {
    hideModal: hideCategoryModalForAddEdit,
    saveEntity: saveCategory,
  }
)(AddCategoriesModal);
